/* eslint-disable */
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../Design_Asset_Actions.json";
import { padNumberFormat, getAllNames as getAllNamesUtil, checkForDuplicateName as checkForDuplicateNameUtil } from "./designAssetUtils";
import { generateRandom } from "../../../utils/randomGenerator";

const useAssetOperations = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
    allowedCbCount,
    allowedLoadCount
  } = deps;

  // Cross-hook function aliases
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const setAlertMessage = (...args) => fnRef.current.setAlertMessage(...args);
  const generateComponentsBlock = (...args) => fnRef.current.generateComponentsBlock(...args);
  const calculateCoOridinates = (...args) => fnRef.current.calculateCoOridinates(...args);
  const assetDetailsReset = (...args) => fnRef.current.assetDetailsReset(...args);
  const updateLoadHistory = (...args) => fnRef.current.updateLoadHistory(...args);
  const updateLoadCbHistory = (...args) => fnRef.current.updateLoadCbHistory(...args);
  const updateDerHistory = (...args) => fnRef.current.updateDerHistory(...args);
  const updateAssetCbHistory = (...args) => fnRef.current.updateAssetCbHistory(...args);
  const updateDerStatus = (...args) => fnRef.current.updateDerStatus(...args);
  const setConfirmMessage = (...args) => fnRef.current.setConfirmMessage(...args);
 const updatePvHistoryFull = (...args) => fnRef.current.updatePvHistoryFull(...args);
  const getAllNames = () => getAllNamesUtil(CBAssetList, CBLoadList, CBEVList, PVDetails);
 const updatePvHistoryGroupPower = (...args) => fnRef.current.updatePvHistoryGroupPower(...args);
  const checkForDuplicateName = (name, currentName) => checkForDuplicateNameUtil(name, currentName, getAllNames);

  //* add assets start

  const addGensetVerify = () => {
    if (siteType === embLabels.GRID_CONNECTED) {
      callSnackbar(
        `error`,
        `'Always Grid connected' usecase doesn't need Genset system.`
      );
    } else {
      if (useCaseValidGenset) {
        
        
        setTimeout(() => {
          addGenset();
        }, 500);
       
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS Main No Genset' usecase doesn't need Genset system.`
        );
      }
    }
  };

  const addGenset = () => {
    setLoading(true);
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[1].uiData.status) {
          assetDetailsReset();
          CBAssetListDispatch({
            type: ACTIONS.ADD_GENSET,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              defaultPmData: defaultPmData,
              gensetData: gensetAssetData,
              projectKind: projectKind,
              projectTypeValue
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };
         
          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
             setLoading(false);
          }, 200);
          sessionStorage.setItem("componentDataModified",true);
          
        } else {
          setLoading(false);
          callSnackbar(`error`, `Max one genset is allowed`);
        }
      } else {
        setLoading(false);
        callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
      }
    } else {
      setLoading(false);
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addBattery = () => {
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[2].uiData.status) {
          assetDetailsReset();

          CBAssetListDispatch({
            type: ACTIONS.ADD_BESS,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };
          sessionStorage.setItem("componentDataModified",true);
          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);

          // this.setState({
          //   batteryCommunicationData: newBatteryData[2].communicationData,
          // });
        } else {
          callSnackbar(`error`, `Max one battery is allowed`);
        }
      } else {
        callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addPv = () => {
    if (UserScope.access.saveSLD) {
      PVDetailsDispatch({
        type: ACTIONS.ADD_PV_EQUIPMENT,
        payload: {
          CBAssetList: CBAssetList,
        },
      });
      sessionStorage.setItem("componentDataModified",true);
      // const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      //   setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addPVSetWithCB = () => {
    setConsiderSelected(false)
    const projectType = projectTypeValue
    if (PVDetails?.pvCount) {
      let overLoadAsset = 0;
      let overLoadPvCB = 1;
      let selectedPv = 3;

      if (PVDetails?.existOrNew === "new") {
        if (checkSLDCount()) {
          overLoadAsset = 1;

          if (!CBAssetList[3]?.uiData?.status) {
            selectedPv = 3;
          } else if (!CBAssetList[4]?.uiData?.status) {
            selectedPv = 4;
          } else if (
            !CBAssetList[5]?.uiData?.status &&
            projectType !== "DaaS IEC"
          ) {
            selectedPv = 5;
          } else {
            overLoadPvCB = 0;
          }
        } else {
          overLoadAsset = 0;
        }
      } else if (PVDetails?.existOrNew === "exist") {
        overLoadAsset = 1;
        selectedPv = parseInt(PVDetails?.branchName);
      }

      //* selected pv is  1
      if (selectedPv === 3) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }

          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
                externalIds[
                  Math.floor(generateRandom()* (externalIds.length - 11) + 11)
                ],
            },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if ((clientType === "GREENSTRUXURE" || clientType === "GENERIC") && checkSLDCount()) {
            if (projectType === "DaaS IEC") {
              callSnackbar(
                "error",
                `Max 2 circuit breakers are allowed for photovoltaic`
              );
            } else {
              callSnackbar(
                "error",
                `Max 3 circuit breakers are allowed for photovoltaic`
              );
            }
          } else {
            callSnackbar("error", `Max ${allowedCbCount} circuit breakers are allowed`);
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }

      //* selected pv is 2
      else if (selectedPv === 4) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType,
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }
          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
                externalIds?.[
                  Math.floor(generateRandom() * (externalIds?.length - 11) + 11)
                ],
            },
          });
          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if (!overLoadPvCB) {
            callSnackbar(
              "error",
              `Max 3 circuit breakers are allowed for photovoltaic`
            );
          } else {
            callSnackbar("error", `Max ${allowedCbCount} circuit breakers are allowed`);
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }

      //* selected pv is 3
      else if (selectedPv === 5) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }
          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
              externalIds[
                Math.floor(generateRandom() * (externalIds.length - 11) + 11)
              ],
            },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if (!overLoadPvCB) {
            callSnackbar(
              "error",
              `Max 3 circuit breakers are allowed for photovoltaic`
            );
          } else {
            callSnackbar("error", `Max ${allowedCbCount} circuit breakers are allowed`);
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }
    }
    setIsAssetConfigChanged(configData);
    
  };

  const addCHPVerify = () => {
    if (!defaultPreFillData[1].remoteMonitoringControl) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Remote monitoring control is required for CHP.`
      );
    } else {
      addCHP();
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const addCHP = () => {
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[6]?.uiData?.status) {
          assetDetailsReset();

          CBAssetListDispatch({
            type: ACTIONS.ADD_CHP,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              siteType,
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          callSnackbar(`error`, `Max one CHP is allowed`);
        }
      } else {
        callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addLoad = () => {
    if (UserScope.access.saveSLD) {
      if(checkSLDCount()){
      // if (siteType === embLabels.GRID_CONNECTED) {
      //   callSnackbar(
      //     `error`,
      //     `More than one Load is not allowed in Grid Connected use case.`
      //   );
      // } else 
      if (count.loadCount + count.evCount + count.gTCount >= allowedLoadCount) {
        callSnackbar("error", `Max ${allowedLoadCount} loads are allowed`);
      } else if (
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        siteType === embLabels.ISLANDABLE_GSX &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1]?.mode === "FUEL_SAVER" &&
        count.loadCount + count.evCount + count.gTCount >= allowedLoadCount
      ) {
        callSnackbar("error", `Max ${allowedLoadCount} loads are allowed`);
      } else {
        if (checkSLDCount()) {
          if (count.loadCount + count.evCount + count.gTCount < allowedLoadCount) {
            countDispatch({
              type: ACTIONS.UPDATE_LOAD_COUNT,
              payload: { count: 1 },
            });
            CBLoadListDispatch({
              type: ACTIONS.ADD_LOAD,
              payload: {
                defaultPreData: defaultPreFillData[0],
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData: defaultCbData,
                siteType: siteType,
                pmAssetData: defaultPmData,
                contactor: evContactorData,
                 defaults: (projectKind?.defaults && Object.keys(projectKind.defaults).length > 0)? projectKind.defaults: defaultPreFillData[2],
                projectTypeValue: projectTypeValue,
                cb_Load: cbLoadData,
              },
            });
            CBLoadListDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
              payload: {
                coordinates: coordinates,
                loadSide:loadSide,
                count: count,
                siteType: siteType,
                defaultCbData: defaultCbData,
                projectKind: projectKind,
                switchboardType: switchboardType,
                cb_Load: cbLoadData,
              },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
          }
        } else {
          callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
        }
      }
    }else{
      callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
    }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addRemoteLoad = () => {
    if (UserScope.access.saveSLD) {
        if (checkSLDCount()) {
          if (count.remoteLoadCount<=4) {
            countDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
              payload: { count: 1 },
            });
            CBLoadListDispatch({
              type: ACTIONS.ADD_REMOTE_LOAD,
              payload: {
                defaultPreData: defaultPreFillData[0],
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData: defaultCbData,
                siteType: siteType,
                pmAssetData: defaultPmData,
                cb_Load: cbLoadData,
                projectTypeValue: projectTypeValue
              },
            });
            CBLoadListDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
              payload: {
                coordinates: coordinates,
                loadSide:loadSide,
                count: count,
                siteType: siteType,
                defaultCbData: defaultCbData,
                projectKind: projectKind,
                switchboardType: switchboardType,
              },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
        } else {
          callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
        }
      }else{
      callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
    }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  }


  const addEv = () => {
    if (UserScope.access.saveSLD) {
      if (count.loadCount + count.evCount + count.gTCount >= allowedLoadCount) {
        callSnackbar("error", `Max ${allowedLoadCount} loads are allowed`);
      } else if(count.loadCount==allowedLoadCount &&(projectKind?.isMgaasIecIsland || isNMGaaSETOIsland || projectKind?.isMGaaSETOIsland)){
        callSnackbar("error", "Please remove one load to add EV");
      }else {
        if (checkSLDCount()) {
          if (!CBEVList[0].uiData.status) {
            assetDetailsReset();

            CBEVListDispatch({
              type: ACTIONS.ADD_EV,
              payload: {
                defaultPreFill: defaultPreFillData[0],
                configData: configData,
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData,
                contactor : evContactorData,
                ev: evDefaultData,
                pmEV: evPMData,
                defaults: (projectKind?.defaults && Object.keys(projectKind.defaults).length > 0)? projectKind.defaults: defaultPreFillData[2],
                isEvce:isEvce
              },
            });

            countDispatch({
              type: ACTIONS.UPDATE_EV_COUNT,
              payload: { count: 1 },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
          } else {
            callSnackbar("error", "Max one EV is allowed");
          }
        } else {
          callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
        }
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  const addGroundingTransformer = () =>{
    if (UserScope.access.saveSLD) {
       if (count.loadCount + count.evCount + count.gTCount >= allowedLoadCount) {

       } else if(count.loadCount + count.gTCount  == allowedLoadCount &&( projectKind?.isMgaasAnsiIsland||projectKind?.isMGaaSETOIsland || projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland)){
        callSnackbar("error", "Please remove one load or EV to add Grounding Transformer");
      } else {
        if (checkSLDCount()) {
          if (!CBGTList[0].uiData.status) {
            assetDetailsReset();
            // let mockData = {
            //       "assetId": 45,
            //       "assetType": "EV_charging_station",
            //       "manufacturer": "GENERIC EV",
            //       "communicationModel": "GENERIC EV",
            //       "imageLink": null,
            //       "assetInfo": "Hardwired",
            //       "assetEnabled": true,
            //       "assetProperties": [],
            //       "assetAttributes": [],
            //       "comments": "Not available as standard, Contact Schneider-Electric support team for integration in your application",
            //       "isExtendedLibrary": false
            //   }
            CBGTListDispatch({
              type: ACTIONS.ADD_GT,
              payload: {
                defaultPreFill: defaultPreFillData[0],
                configData: configData,
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData,
                contactor : gTContractorData,
                gt: defaultGTData,
              },
            });

            countDispatch({
              type: ACTIONS.UPDATE_GT_COUNT,
              payload: { count: 1 },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
          } else {
            callSnackbar("error", "Max one GT is allowed");
          }
        } else {
          callSnackbar(`error`, `Max ${allowedCbCount} circuit breakers are allowed`);
        }
      }
    }else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  }

  const addTransferSwitch = () =>
    setAlertMessage(
      `Alert`,
      false,
      ``,
      `Contact SE representative in order to integrate external transfer switch.`
    );

  //* add assets end

  //* remove assets start

  const checkGensetRemoveCondition = () => {
    if (defaultPreFillData[1].mode === "FUEL_SAVER") {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'Genset main, BESS grid tied' usecase requires a generator.`
      );
    } else {
      removeGenset();
    }
  };

  const removeGenset = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 1,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      assetGensetDetailsBlock: false,
    }));
    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(1);
    updateDerStatus(1);
    updateAssetCbHistory(1);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const checkBatteryRemoveCondition = () => {
    if (siteType === embLabels.GRID_CONNECTED) {
      // if (!defaultPreFillData[1].exportOptimization) {
      //   removeBattery();
      // } else {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Export management predictive optimization requires a battery system.`
      );
      // }
    } else {
      if (defaultPreFillData[1].mode === "NO_FUEL") {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS main, No Genset' usease requires a battery system. `
        );
      } else if (defaultPreFillData[1].mode === "FUEL_ERASER") {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS main, Genset as backup' usease requires a battery system.`
        );
      } else {
        if (!defaultPreFillData[1].exportOptimization) {
          removeBattery();
        } else {
          setAlertMessage(
            `Alert`,
            false,
            ``,
            `Export management predictive optimization requires a battery system.`
          );
        }
      }
    }
  };

  const removeBattery = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 2,
        configData,
      },
    });

    setDetailsBlock((prevState) => ({
      ...prevState,
      assetBatteryDetailsBlock: false,
    }));

    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(2);
    updateDerStatus(2);
    updateAssetCbHistory(2);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const removePvWithAlert = (subPv) => {
    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      PVDetails?.pvset1Data?.length === 1
    ) {
      if (architectureType === embLabels.PV_GENSET_ATS) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
        );
      }
    }
    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      PVDetails?.pvset1Data?.length === 1
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV`
        );
      }
    }
    //  else if (
    //   siteType === embLabels.PV_HYBRIDIZATION &&
    //   PVDetails.pvset1Data.length === 1
    // ) {
    //   setAlertMessage(
    //     `Alert`,
    //     false,
    //     ``,
    //     `'Genset/PV Hybridization' usecase requires minimum one PV`
    //   );
    // } 
    else {
      setSelectedValues((prevState) => ({ ...prevState, selectSubPv: subPv }));

      setConfirmMessage(`Do you confirm to delete pv from  pv set ?`);
    }
  };

  const checkPVCount = () => {
    const isArray1Empty = PVDetails?.pvset1Data?.length === 0;
    const isArray2Empty = PVDetails?.pvset2Data?.length === 0;
    const isArray3Empty = PVDetails?.pvset3Data?.length === 0;
    if(((isArray1Empty&&isArray2Empty&&!isArray3Empty)||
    (isArray1Empty&&!isArray2Empty&&isArray3Empty)||
    (!isArray1Empty&&isArray2Empty&&isArray3Empty))){
      return true;
    }else{
      return false;
    }
  }

  const removePv = () => {
    const isPVEmpty = checkPVCount();
    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1]?.mode === "FUEL_SAVER" &&
      isPVEmpty
    ) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
      );
    } else if (
      siteType === embLabels.ISLANDABLE_GSX &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1]?.mode !== "FUEL_SAVER"
    ) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
      );
    }else if((siteType===embLabels.ISLANDABLE ||siteType===embLabels.OFF_GRID )&&
      defaultPreFillData[1]?.mode === "FUEL_ERASER"&&
      isPVEmpty
    ){
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌BESS Main Genset as backup' usecase requires minimum one PV`
      );
    } else if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      isPVEmpty
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV1`
        );
      }
    } else if (
      siteType === embLabels.GRID_CONNECTED &&
      isPVEmpty
    ) {
      setAlertMessage(`Alert`, false, ``, ` usecase requires minimum one PV1`);
    } else if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      isPVEmpty
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV1`
        );
      }
    } 
    else if (siteType === embLabels.PV_HYBRIDIZATION && isPVEmpty) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'Genset/PV Hybridization' usecase requires minimum one PV`
      );
    }
    else if((siteType===embLabels.ISLANDABLE ||  siteType === embLabels.OFF_GRID)&&isPVEmpty){
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'Genset main, BESS grid tied' usecase requires minimum one PV`
      );
    }
     else {
      CBAssetListDispatch({
        type: ACTIONS.REMOVE_ASSET_DER_PV,
        payload: {
          selectedPv: PVDetails?.selectedPv,
        },
      });
      setDetailsBlock((prevState) => ({
        ...prevState,
        assetPvDetailsBlock: false,
      }));

      countDispatch({
        type: ACTIONS.UPDATE_DER_COUNT,
        payload: { count: -1 },
      });

      let removedPvSet;
      switch (PVDetails?.selectedPv) {
        case 3:
          removedPvSet = "pvset1Data";
          break;
        case 4:
          removedPvSet = "pvset2Data";

          break;
        case 5:
          removedPvSet = "pvset3Data";

          break;
        default:
          break;
      }
      PVDetailsDispatch({
        type: ACTIONS.REMOVE_ALL_PV_FROM_SET,
        payload: {
          removedPvSet: removedPvSet,
        },
      });

      updatePvHistoryFull(PVDetails?.selectedPv);
      updateAssetCbHistory(PVDetails?.selectedPv);
      updatePvHistoryGroupPower(PVDetails?.selectedPv);

      const runCalculateCoordinatesNew = { componentPush: true };

      setTimeout(() => {
        setRunCalculateCoordinates(runCalculateCoordinatesNew);
      }, 100);
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const removeCHP = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 6,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      assetCHPDetailsBlock: false,
    }));
    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(6);
    updateDerStatus(7);
    updateAssetCbHistory(6);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };
const checkRemoteLoads = (index)=>{
  const load = CBLoadList[index];
  if (load?.uiData?.isRemoteLoad === true) {
    return true;
  }else{
    return false;
  }
 
}
  const removeLoad = (index) => {
    if (siteType === embLabels.GRID_CONNECTED && !isExportOptimization) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Asset configuration needs minimum one load.`
      );
    } else if ((parseInt(count.loadCount) === 1) && !checkRemoteLoads(index)) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Asset configuration needs minimum one load.`
      );
    } else {
      CBLoadListDispatch({
        type: ACTIONS.REMOVE_LOAD,
        payload: {
          selectedLoad: index,
        },
      });

      
      if(CBLoadList[index].uiData.isRemoteLoad){
        countDispatch({
          type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
          payload: { count: -1 },
        });
      }else{
        countDispatch({
          type: ACTIONS.UPDATE_LOAD_COUNT,
          payload: { count: -1 },
        });
      }

      // setDetailsBlock((prevState) => ({
      //   ...prevState,
      //   loadDetailsBlock: false,
      // }));

      updateLoadHistory(index);
      updateLoadCbHistory(index);

      const runCalculateCoordinatesNew = { componentPush: true };

      setTimeout(() => {
        setRunCalculateCoordinates(runCalculateCoordinatesNew);
      }, 100);
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const removeEv = () => {
    CBEVListDispatch({
      type: ACTIONS.REMOVE_ASSET_EV,
      payload: {
        index: 0,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      evDetailsBlock: false,
    }));

    countDispatch({
      type: ACTIONS.UPDATE_EV_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(5);
    updateDerStatus(5);
    updateAssetCbHistory(6);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };
  const removeGt = (index) => {
    CBGTListDispatch({
      type: ACTIONS.REMOVE_GT,
      payload: {
        index: index,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      gtDetailsBlock: false,
    }));

    countDispatch({
      type: ACTIONS.UPDATE_GT_COUNT,
      payload: { count: -1 },
    });
    
    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  //* remove assets end

  const isNoAssetSelected = () =>
    Object.keys(detailsBlock).every((block) => !detailsBlock[block]);

  const checkSLDCount = () =>
   cbCount?.assetCbCount >= allowedCbCount ? false : true;

  //* isValidCBName and isValidName are now imported from designAssetUtils.js


  return {
    getAllNames,
    checkForDuplicateName,
    addGensetVerify,
    addGenset,
    addBattery,
    addPv,
    addPVSetWithCB,
    addCHPVerify,
    addCHP,
    addLoad,
    addRemoteLoad,
    addEv,
    addGroundingTransformer,
    addTransferSwitch,
    checkGensetRemoveCondition,
    removeGenset,
    checkBatteryRemoveCondition,
    removeBattery,
    removePvWithAlert,
    checkPVCount,
    removePv,
    removeCHP,
    checkRemoteLoads,
    removeLoad,
    removeEv,
    removeGt,
    isNoAssetSelected,
    checkSLDCount,
  };
};

export default useAssetOperations;